import { shouldTriggerWeekendAlert } from '@massilia/queries'

export function shouldShowWeekendBanner(summary: {
  fareValidityDeadline?: string
  ticketingDeadline?: string
}): boolean {
  return shouldTriggerWeekendAlert({
    fareValidityDeadline: summary.fareValidityDeadline ? new Date(summary.fareValidityDeadline) : null,
    ticketingDeadline: summary.ticketingDeadline ? new Date(summary.ticketingDeadline) : null,
  })
}
